import { useCallback, useMemo } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { filtersFromUrl, parseYear, urlForFilters } from '../lib/filterUrl.js'

// #338: the calendar's and the map's filter state, read from and written to the
// URL instead of `useState`.
//
// Nothing here holds state. The URL is the single source of truth, which is
// what makes every view a permalink, makes the back button step through filter
// changes, and removes the class of bug where the control says one thing and
// the request sends another.
//
// `basePath` is '' for the calendar and '/map' for the map.
export default function useFilterRoute(basePath = '') {
  const { year: yearParam } = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const year = parseYear(yearParam)
  // A bad year segment is reported rather than swallowed: /banana must not
  // render an empty calendar that reads as "no events".
  const invalidYear = yearParam != null && year == null

  // URLSearchParams is a fresh object on every render, so memoise on its
  // serialised form — otherwise every render produces a new filters object and
  // the fetch effect downstream loops.
  const search = searchParams.toString()
  const filters = useMemo(
    () => filtersFromUrl(yearParam, new URLSearchParams(search)),
    [yearParam, search],
  )

  const setFilters = useCallback(
    (next) => navigate(urlForFilters(basePath, next || {})),
    [basePath, navigate],
  )

  return { year, invalidYear, filters, setFilters }
}
